var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgOndasBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 481.586,
    viewBox: "0 0 1920 481.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_ondas_banner",
    transform: "translate(4.32 -97.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20414",
    "data-name": "Path 20414",
    d: "M1381.007,195.432c-276.824,0-276.824-97.579-553.652-97.579-276.774,0-276.774,97.579-553.548,97.579-139.212,0-208.437-24.673-278.06-49.205V320.692H1915.159V98.038C1657.732,102.522,1651.163,195.432,1381.007,195.432Z",
    transform: "translate(0.212 0)",
    fill: "#0367a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20415",
    "data-name": "Path 20415",
    d: "M1657.141,124.5c-276.836,0-276.836,97.574-553.672,97.574S826.641,124.5,549.817,124.5c-276.774,0-276.774,97.574-553.552,97.574h-.517V367.918H1915.159V166.705C1851.692,144.692,1783.058,124.5,1657.141,124.5Z",
    transform: "translate(0.212 83.053)",
    fill: "#0595f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20416",
    "data-name": "Path 20416",
    d: "M1391.04,254.955c-276.828,0-276.828-97.574-553.652-97.574-276.774,0-276.774,97.574-553.552,97.574-145.888,0-214.919-27.093-288.088-52.729v87.418H1915.159V157.784C1667.542,164.474,1657.641,254.955,1391.04,254.955Z",
    transform: "translate(0.212 185.542)",
    fill: "#3ec8fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20417",
    "data-name": "Path 20417",
    d: "M1462.412,226.961c-276.77,5.624-285.91,85.652-483.02,87.99-276.753,3.281-372.216-97.578-648.99-97.578C184.51,217.373,68.849,244.466-4.32,270.1V182.684h1920V289.843C1668.063,283.153,1576.307,224.643,1462.412,226.961Z",
    transform: "translate(0 264.409)",
    fill: "#3ec8fc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOndasBanner);
export default __webpack_public_path__ + "static/media/img_ondas_banner.b7f9bc41eec8d0bfb6c2575a6f4b5da9.svg";
export { ForwardRef as ReactComponent };